import * as Yup from "yup";
/* eslint-disable no-useless-escape */
const ChangePhoneNumberValidation = (t, countryCode) => {
  return Yup.object().shape({
    phone_number: Yup.string()
      .required(t("auth.phoneNumber.validMessage"))
      .matches(
        countryCode === "TR"
          ? /^\(\d{3}\)\s\d{3}\s\d{4}$/ // (XXX) XXX XXXX
          : /^\d{13}$/, // 13 rakam
        t("auth.phoneNumber.validMessage")
      ),
  });
};
export default ChangePhoneNumberValidation;
